@if (unusedUsers && unusedGroups) {
    <div class="accessibilities" cdkDropListGroup>
        <div class="accessibilities-container">
            @if (!disabled) {
                <mat-tab-group class="unused-items-tab-group">
                    <mat-tab label="Utilisateurs" class="tab unused-users-container">
                        <div class="drop-list-container">
                            <div
                                id="unused-users"
                                cdkDropList
                                cdkDropListSortingDisabled
                                [cdkDropListData]="unusedUsers"
                                class="drop-list drop-target"
                                (cdkDropListDropped)="drop($event)"
                                [cdkDropListDisabled]="disabled">
                                @for (item of unusedUsers; track item) {
                                    <div class="drop-item user-item" cdkDrag cdkDragPreview>
                                        <fa-icon [icon]="faGripLinesVertical" class="fa-lg drag-handle" cdkDragHandle></fa-icon>
                                        <fa-icon [icon]="faUser" class="fa-1x type"></fa-icon>
                                        <span class="label" [title]="item.account">{{ item.displayName }}</span>
                                    </div>
                                }
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="Groupes d'Utilisateurs" class="tab unused-groups-container">
                        <div class="drop-list-container">
                            <div
                                id="unused-groups"
                                cdkDropList
                                cdkDropListSortingDisabled
                                [cdkDropListData]="unusedGroups"
                                class="drop-list drop-target"
                                (cdkDropListDropped)="drop($event)"
                                [cdkDropListDisabled]="disabled">
                                @for (item of unusedGroups; track item) {
                                    <div class="drop-item group-user-item" cdkDrag cdkDragPreview>
                                        <fa-icon [icon]="faGripLinesVertical" class="fa-lg drag-handle" cdkDragHandle></fa-icon>
                                        <fa-icon [icon]="faUsers" class="fa-1x type"></fa-icon>
                                        <span class="label">{{ item.name }}</span>
                                    </div>
                                }
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>
                <div class="drag-buttons-container">
                    <button mat-raised-button class="primary-button move-item" (click)="moveAllUsersInAccessibility()">
                        Tout déplacer
                        <fa-icon
                            [icon]="faAngleDoubleRight"
                            class="fa-1x move-item-icon"
                            matTooltipPosition="right"
                            matTooltipHideDelay="50"
                            matTooltipClass="info-tooltip"></fa-icon>
                    </button>
                    <button mat-raised-button class="primary-button move-item" (click)="removeAllAccessibilities()">
                        <fa-icon
                            [icon]="faAngleDoubleLeft"
                            class="fa-1x move-item-icon"
                            matTooltipPosition="right"
                            matTooltipHideDelay="50"
                            matTooltipClass="info-tooltip"></fa-icon>
                        Tout déplacer
                    </button>
                </div>
            }
            <div class="drag-container">
                <div class="drag-container-header"><span>Accessible par</span></div>
                <div class="drop-list-container">
                    <div
                        id="accessibilities"
                        cdkDropList
                        cdkDropListSortingDisabled
                        [cdkDropListData]="accessibilities"
                        class="drop-list drop-target"
                        (cdkDropListDropped)="drop($event)"
                        [cdkDropListDisabled]="disabled">
                        @for (item of accessibilities; track item) {
                            <div class="drop-item view-item" cdkDrag cdkDragPreview [cdkDragDisabled]="item.isInherited">
                                @if (!disabled) {
                                    @if (item.isInherited) {
                                        <fa-icon [icon]="faGripLinesVertical" class="fa-lg drag-handle fa-disabled"></fa-icon>
                                    } @else {
                                        <fa-icon [icon]="faGripLinesVertical" class="fa-lg drag-handle" cdkDragHandle></fa-icon>
                                    }
                                }
                                @if (item.userId) {
                                    <fa-icon [icon]="faUser" class="fa-1x type"></fa-icon>
                                    <span class="label">{{ item.userName }}</span>
                                }
                                @if (item.groupId) {
                                    <fa-icon [icon]="faUsers" class="fa-1x type"></fa-icon>
                                    <span class="label">{{ item.groupName }}</span>
                                }
                                @if (item.isInherited) {
                                    <fa-icon [icon]="faSitemap" class="fa-lg hierarchy-icon"></fa-icon>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
}
